import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12 4c4.432 0 8 3.568 8 8s-3.568 8-8 8-8-3.568-8-8 3.568-8 8-8" }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M12 10.057c-.686 0-1.232-.56-1.232-1.246S11.314 7.579 12 7.579s1.232.546 1.232 1.232-.546 1.246-1.232 1.246m-1.078 6.364v-5.762h2.156v5.762z"
    }, null, -1)
  ]))]))
}
export default { render: render }